import type { ReactNode } from "react";
import { ModuleRouteGuard } from "@/modules/ModuleRouteGuard";
import { ViewAsCompanyBar } from "@/modules/platform/ViewAsCompanyBar";
import { Layout } from "./Layout";
import { NavigationLayoutAccountSync } from "./NavigationLayoutAccountSync";
import { useNavigationLayoutPreference } from "./navigationLayoutPreference";
import { SidebarLayout } from "./SidebarLayout";

export const DesktopLayout = ({ children }: { children: ReactNode }) => {
  const [layoutMode] = useNavigationLayoutPreference();

  return (
    <>
      <NavigationLayoutAccountSync />
      <ViewAsCompanyBar />
      {layoutMode === "sidebar" ? (
        <SidebarLayout>
          <ModuleRouteGuard>{children}</ModuleRouteGuard>
        </SidebarLayout>
      ) : (
        <Layout>
          <ModuleRouteGuard>{children}</ModuleRouteGuard>
        </Layout>
      )}
    </>
  );
};
